import React from 'react';
import { Field } from 'react-final-form';
import RequiredLabel from '../RequiredLabel/RequiredLabel';

const ValidatedLabel = (props) => {
    return (
      <Field name={props.name}>
          {({ input, meta }) => (
            <div className={(meta.submitError || meta.error && meta.touched) ? 'has-danger' : !meta.error && meta.touched ? 'form-group has-success' : 'form-group' + " " + props.groupClassName}>
                {props.required ?  
                    <>
                        <RequiredLabel  {...input} {...props} className={(meta.submitError || meta.error && meta.touched) ? 'is-invalid' : !meta.error && meta.touched && !meta.submitError ? 'is-valid' : '' + props.className}>{props.label}</RequiredLabel>
                        {(meta.submitError || meta.error && meta.touched) && <div className="invalid-feedback" style={{display:'block'}}>{meta.error ? meta.error : meta.submitError}</div>}
                    </> :
                    <>
                        <label  {...input} {...props} className={(meta.submitError || meta.error && meta.touched) ? 'is-invalid' : !meta.error && meta.touched && !meta.submitError ? 'is-valid' : '' + props.className}>{props.label}</label>
                        {(meta.submitError || meta.error && meta.touched) && <div className="invalid-feedback" style={{display:'block'}}>{meta.error ? meta.error : meta.submitError}</div>}
                    </>
                }
                
              {/* {(meta.submitError || meta.error && meta.touched) && <span className="invalid-feedback" style={{display:'inline'}}>1{meta.error ? meta.error : meta.submitError}1</span>} */}
                {/* <label {...input} {...props} className={(meta.submitError || meta.error && meta.touched) ? 'form-control is-invalid' : !meta.error && meta.touched && !meta.submitError ? 'form-control is-valid' : 'form-control'} placeholder={props.placeholder} >{props.label}</label> */}
            </div>
          )}
      </Field>
    );
  };
  
  /*
  <div className="invalid-feedback" style={{visibility: meta.error && meta.touched ? 'visible' : 'hidden'}}>{meta.error}</div>
  
  */
  export default ValidatedLabel;
  